import LcView from "lib/shared/view";

export default LcView.create({
  ready: () => {}
});
